import { render, staticRenderFns } from "./OffCanvasLayout.vue?vue&type=template&id=94117464&scoped=true"
import script from "./OffCanvasLayout.vue?vue&type=script&lang=js"
export * from "./OffCanvasLayout.vue?vue&type=script&lang=js"
import style0 from "./OffCanvasLayout.vue?vue&type=style&index=0&id=94117464&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94117464",
  null
  
)

export default component.exports